<template>
  <svg
    width="46"
    height="44"
    viewBox="0 0 46 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.8098 0.58541C22.8697 0.401148 23.1303 0.401148 23.1902 0.58541L28.3434 16.4454C28.3702 16.5278 28.447 16.5836 28.5336 16.5836H45.2098C45.4036 16.5836 45.4841 16.8315 45.3274 16.9454L31.8361 26.7474C31.766 26.7983 31.7366 26.8886 31.7634 26.971L36.9166 42.831C36.9765 43.0153 36.7656 43.1685 36.6089 43.0546L23.1176 33.2526C23.0475 33.2017 22.9525 33.2017 22.8824 33.2526L9.39113 43.0546C9.23439 43.1685 9.02349 43.0153 9.08337 42.831L14.2366 26.971C14.2634 26.8886 14.234 26.7983 14.1639 26.7474L0.672624 16.9454C0.515881 16.8315 0.596436 16.5836 0.790181 16.5836H17.4664C17.553 16.5836 17.6298 16.5278 17.6566 16.4454L22.8098 0.58541Z"
      class="fill-current"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconStar extends Vue {}
</script>
